import React from 'react';
interface FloatingBadgeProps {
  text: string;
  icon?: React.ReactNode;
  delay?: number;
  className?: string;
}
const FloatingBadge: React.FC<FloatingBadgeProps> = ({
  text,
  icon,
  delay = 0,
  className = ''
}) => {
  return <div className={`inline-flex items-center gap-2 px-6 py-3 bg-white/90 backdrop-blur-xl rounded-full shadow-lg animate-float-random ${className}`} style={{
    animationDelay: `${delay}s`
  }} data-id="element-78">
      {icon && <div className="text-primary-600" data-id="element-79">{icon}</div>}
      <span className="font-semibold text-gray-800" data-id="element-80">{text}</span>
    </div>;
};
export default FloatingBadge;